function t(n) {
  return function(r) {
    return n(r);
  };
}
export {
  t as default
};
